// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AuthContext from "../../context/AuthContext.bs.js";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";

function ProtectedRoute$ProtectedRoute(props) {
  let auth = AuthContext.useAuth();
  let match = auth.state;
  if (typeof match === "object") {
    return props.children;
  }
  RescriptReactRouter.push("/login");
  return null;
}

let ProtectedRoute = {
  make: ProtectedRoute$ProtectedRoute
};

export {
  ProtectedRoute,
}
/* AuthContext Not a pure module */
